<mat-form-field mat-input-height-large-label [style.width]="width">
  <mat-label>{{ placeholder }}</mat-label>
  <input matInput fieldTextContentTooltip #input [matAutocomplete]="auto" [formControl]="formControl" />
  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="onDropdownSelect($event.option.value)"
    (opened)="onDropdownOpen()"
  >
    <cdk-virtual-scroll-viewport
      [ngStyle]="{ height: autocompleteHeight }"
      [itemSize]="elementHeight"
    >
      <mat-option
        fieldTextContentTooltip
        [ngStyle]="{ height: elementHeight + 'px' }"
        *cdkVirtualFor="let value of autocompleteValues; trackBy: autocompleteValuesTrackBy"
        [value]="value"
      >
        <span class="value">{{ value?.viewValue }} </span>
        <span>{{ value?.viewValueTwo ? '(' + value.viewValueTwo + ')' : '' }}</span>
        <span class="sub-value">{{ value?.viewValueThree }}</span>
      </mat-option>
    </cdk-virtual-scroll-viewport>
  </mat-autocomplete>
</mat-form-field>
